class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinkDesktop = document.querySelector('#cart-icon-bubble');
    const cartLinkTablet = document.querySelector('#cart-icon-bubble-tablet');
  
    [cartLinkDesktop, cartLinkTablet].forEach(cartLink => {
      if (cartLink) {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.getSectionsToRender().forEach((section) => {

        const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
        
        // Check if the sectionElement is found before proceeding
        if (sectionElement) {
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        } else {
            console.error(`Element not found for selector: ${section.selector}`);
        }
    });

    setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
        if (typeof initPromoSlider === 'function') {
          initPromoSlider();
        }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
// Function to add item to the cart
function addItemToCart(variantID) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.add('is-loading');
  }

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest',
    },
    body: JSON.stringify({
      id: variantID,
      quantity: 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
    }),
  })
    .then((response) => response.json())
    .then((response) => {
      const state = {
        sections: {
          'cart-drawer': response.sections['cart-drawer'],
          'cart-icon-bubble': response.sections['cart-icon-bubble'],
        },
      };

      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer) {
        cartDrawer.renderContents(state);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      const errorMessage = document.querySelector('.cart-error-message');
      if (errorMessage) {
        errorMessage.textContent = window.customStrings?.cart_update_error || '';
        errorMessage.style.display = 'block';
      }
    })
    .finally(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-loading');
      }
    });
}

// Function to remove item from the cart
function removeItemFromCart(variantID) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.add('is-loading');
  }

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const line = cart.items.findIndex((item) => item.variant_id === variantID) + 1;

      if (line === 0) {
        throw new Error('Item not found in cart');
      }

      const body = JSON.stringify({
        line: line.toString(),
        quantity: 0,
        sections: ['cart-drawer', 'cart-icon-bubble'],
      });

      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
        body,
      });
    })
    .then((response) => response.json())
    .then((response) => {
      const state = {
        sections: {
          'cart-drawer': response.sections['cart-drawer'],
          'cart-icon-bubble': response.sections['cart-icon-bubble'],
        },
      };

      if (cartDrawer) {
        cartDrawer.renderContents(state);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      const errorMessage = document.querySelector('.cart-error-message');
      if (errorMessage) {
        errorMessage.textContent = window.customStrings?.cart_update_error || '';
        errorMessage.style.display = 'block';
      }
    })
    .finally(() => {
      if (cartDrawer) {
        cartDrawer.classList.remove('is-loading');
      }
    });
}

// Main function to handle checkbox change
function handleCheckboxChange(checkbox) {
  const variantID = 47121363960152;

  if (checkbox.checked) {
    // If checkbox is checked, add the item to the cart
    addItemToCart(variantID);
  } else {
    // If checkbox is unchecked, remove the item from the cart
    removeItemFromCart(variantID);
  }
}
document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return msie > 0 || trident > 0;
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function (event) {
      document.querySelector('#cart').submit();
    });
  });
// Free shipping thresholds in cents by shipping cost amount
var threshold = {
  // EUR thresholds
  9: 9800,    // 98€ for 9€ shipping (EU)
  
  // GBP thresholds
  23: 23000,  // £230 for £23 shipping (UK)
  
  // USD thresholds
  35: 35000,  // $350 for $35 shipping (US)
  
  // CAD thresholds
  40: 45000,  // $450 CAD for $40 shipping (Canada)
  
  // AUD thresholds
  49: 49500,  // $495 AUD for $49 shipping (Australia)
  
  // NOK thresholds
  240: 250000, // 2500 NOK for 240 NOK shipping (Norway)
  
  // CHF thresholds
  25: 24000,  // 240 CHF for 25 CHF shipping (Switzerland)

  // Singapore thresholds
  39: 39900,  // 399 SGD for 39 SGD shipping (Singapore)

  // Arab emirates thresholds
  117: 120000,  // 1200 UAE for 117 UAE shipping (Arab emirates)

  // Sweden thresholds
  290: 260000,  // 2600 SEK for 290 SEK shipping (Sweden)
  
  null: 27500 // Default fallback
}

const drawer = document.getElementById('CartDrawer');

// --- Cart delivery text (same logic as product detail: preorder_starts / arrives_between) ---
const CART_DELIVERY_HOLIDAYS = new Set([
  "2026-01-01", "2026-01-06", "2026-04-03", "2026-04-06", "2026-05-01", "2026-06-24",
  "2026-08-15", "2026-09-11", "2026-10-12", "2026-12-08", "2026-12-25", "2026-12-26"
]);

function cartAddBusinessDaysAsDate(days) {
  const d = new Date();
  let count = 0;
  while (count < days) {
    d.setDate(d.getDate() + 1);
    if (d.getDay() === 0 || d.getDay() === 6) continue;
    if (CART_DELIVERY_HOLIDAYS.has(d.toISOString().split('T')[0])) continue;
    count++;
  }
  return d;
}

function cartAddBusinessDaysFormatted(days, translations) {
  const d = cartAddBusinessDaysAsDate(days);
  const lang = (translations && translations.language) || 'en';
  const day = d.getDate();
  const month = d.toLocaleString(lang, { month: 'short' });
  if (lang === 'es') return `${day} ${month}`;
  const suffixes = ["th", "st", "nd", "rd"];
  const n = day % 100;
  const suffix = (n >= 11 && n <= 13) ? "th" : (suffixes[n % 10] || "th");
  return `${month} ${day}${suffix}`;
}

// Parse pre-order date from Shopify Date metafield (comes as ISO string: "2025-02-28" or "2025-02-28T00:00:00Z").
// The date will be formatted for display according to the active language in cartFormatDateForDisplay.
// Parse date-only string (meta has no time). "YYYY-MM-DD" -> local Date at midnight.
function cartParsePreOrderDate(dateString) {
  if (!dateString || typeof dateString !== 'string') return null;
  const s = dateString.trim();
  if (!s || s === 'null') return null;
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const date = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
  return isNaN(date.getTime()) ? null : date;
}

function cartFormatDateForDisplay(date, translations) {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) return '';
  const lang = (translations && translations.language) || 'en';
  const day = date.getDate();
  const month = date.toLocaleString(lang, { month: 'short' });
  if (lang === 'es') return `${day} ${month}`;
  const suffixes = ["th", "st", "nd", "rd"];
  const n = day % 100;
  const suffix = (n >= 11 && n <= 13) ? "th" : (suffixes[n % 10] || "th");
  return `${month} ${day}${suffix}`;
}

function updateCartDeliveryText() {
  const script = document.querySelector('#CartDrawer script[data-cart-delivery]');
  const span = document.getElementById('cartDrawerDeliveryText');
  if (!script || !span) return;
  let data;
  try {
    data = JSON.parse(script.textContent);
  } catch (e) {
    return;
  }
  const items = data.items || [];
  const t = data.translations || {};
  if (items.length === 0) {
    span.textContent = t.delivery_calculated || span.textContent;
    return;
  }
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  let maxDate = null;
  let maxFromPreOrder = false;
  for (const item of items) {
    const rawPreOrder = item.pre_order_date;
    // Normalize: handle string or object.value, filter out null/empty/"null"
    let preOrderStr = null;
    if (rawPreOrder != null) {
      if (typeof rawPreOrder === 'string') {
        const trimmed = rawPreOrder.trim();
        if (trimmed && trimmed !== 'null' && /^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
          preOrderStr = trimmed;
        }
      } else if (rawPreOrder.value != null && typeof rawPreOrder.value === 'string') {
        const trimmed = String(rawPreOrder.value).trim();
        if (trimmed && trimmed !== 'null' && /^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
          preOrderStr = trimmed;
        }
      }
    }
    const parsedPreOrder = preOrderStr ? cartParsePreOrderDate(preOrderStr) : null;
    const usePreOrderDate = parsedPreOrder && parsedPreOrder >= todayStart;
    const deliveryDate = usePreOrderDate ? parsedPreOrder : cartAddBusinessDaysAsDate(5);
    if (!deliveryDate) continue;
    if (!maxDate || deliveryDate > maxDate) {
      maxDate = deliveryDate;
      maxFromPreOrder = usePreOrderDate;
    }
  }
  if (!maxDate) {
    span.textContent = t.delivery_calculated || span.textContent;
    return;
  }
  if (maxFromPreOrder) {
    const formattedDate = cartFormatDateForDisplay(maxDate, t);
    span.textContent = (t.preorder_starts || 'Shipping starts: {{ date }}').replace('{{ date }}', formattedDate);
  } else {
    const minStr = cartAddBusinessDaysFormatted(3, t);
    const maxStr = cartAddBusinessDaysFormatted(5, t);
    span.textContent = (t.arrives_between || 'Arrives between: {{ min }} - {{ max }}')
      .replace('{{ min }}', minStr)
      .replace('{{ max }}', maxStr);
  }
}
  
// Create a function to update the shipping cost
function modifyDrawerContent() {
  const localData = JSON.parse(localStorage.getItem('themeData'));
  const shippingCostElement = document.querySelector('#shippingCost');
  const totalCartDiv = document.querySelector('#totalCartAdded');
  const totalCartElement = document.querySelector('p[data-total]');
  
  // Verificar que los elementos necesarios existan
  if (!totalCartDiv || !totalCartElement) {
    return;
  }

  const currencySymbol = window.customStrings?.currency_symbol || '';
  const freeLabel = window.customStrings?.free_label || '';
  const totalCart = parseFloat(totalCartElement.getAttribute('data-total'));
  
  if (shippingCostElement != null && localData) {
    if (totalCart >= threshold[localData.shippingCost]) {
      shippingCostElement.textContent = freeLabel;
      totalCartDiv.textContent = currencySymbol + (parseFloat(totalCartElement.getAttribute('data-total')) / 100);
    } else {
      // Format shipping cost with correct currency symbol
      shippingCostElement.textContent = currencySymbol + localData.shippingCost;

      var shippingCost = parseFloat(localData.shippingCost);
      var cartTotal = parseFloat(totalCart) / 100;
      var totalWithShipping = shippingCost + cartTotal;

      // Update the totalCartDiv with the calculated total
      totalCartDiv.textContent = currencySymbol + totalWithShipping;
    }
  } else if (totalCartDiv && totalCartElement) {
    // Si no hay shippingCostElement, al menos mostrar el total del carrito
    totalCartDiv.textContent = currencySymbol + (parseFloat(totalCartElement.getAttribute('data-total')) / 100);
  }
  
  // Update delivery text (same logic as product detail page)
  updateCartDeliveryText();
}
const observer = new MutationObserver(function(mutationsList, observer) {
  // Temporarily disconnect the observer to prevent recursive calls
  observer.disconnect();

  // Call the updateShippingCost function whenever the content of the drawer changes
  modifyDrawerContent();

  // Reconnect the observer to resume observing
  observer.observe(drawer, { childList: true, subtree: true });
});

// Start observing changes in the drawer content
if (drawer) {
  observer.observe(drawer, { childList: true, subtree: true });
}

// Run the updateShippingCost function initially to ensure the shipping cost is updated
modifyDrawerContent();
 
function toggleActiveClass() {
    const reviewDivs = document.querySelectorAll(".drawerReview .review");
    if (reviewDivs.length === 0) {
        // No review elements found, do nothing
        return;
    }

    let activeIndex = -1;

    // Find the index of the currently active review
    for (let i = 0; i < reviewDivs.length; i++) {
      if (reviewDivs[i].classList.contains("active")) {
        activeIndex = i;
        break;
      }
    }

    // Remove the active class from the currently active review
    if (activeIndex !== -1) {
      reviewDivs[activeIndex].classList.remove("active");
    }

    // Calculate the index of the next review to make active
    const nextIndex = (activeIndex + 1) % reviewDivs.length;

    // Add the active class to the next review
    reviewDivs[nextIndex].classList.add("active");
}
// Set the interval to call the function every 5 seconds (5000 milliseconds)
setInterval(toggleActiveClass, 5000);

//promo-slide
//promo-slide
function initPromoSlider() {
  const promoSlides = document.querySelectorAll('.promo-slide');
  if (promoSlides.length === 0) return;
  
  let currentSlide = 0;

  // Limpiar intervalo anterior si existe
  if (window.promoSliderInterval) {
    clearInterval(window.promoSliderInterval);
  }

  // Animación inicial
  setTimeout(() => {
    promoSlides[currentSlide].classList.add('active');
  }, 100);

  function rotatePromo() {
    promoSlides[currentSlide].classList.add('exit');
    
    setTimeout(() => {
      promoSlides[currentSlide].classList.remove('active', 'exit');
      currentSlide = (currentSlide + 1) % promoSlides.length;
      promoSlides[currentSlide].classList.add('active');
    }, 600);
  }

  window.promoSliderInterval = setInterval(rotatePromo, 6000);
}

// Ejecutar al cargar inicialmente
initPromoSlider();